<template>
  <StyledText
    :fontId="fontId"
    :tag="tag"
    ref="targetEl"
    :class="[testClassName]"
  >
    <slot />
  </StyledText>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import StyledText from "./styled/Text.vue";
import { Brand } from "@fresh8/types/src/index";

export default defineComponent({
  name: "Text",
  components: {
    StyledText
  },
  props: {
    tag: {
      type: String as PropType<"p" | "span">,
      required: false,
      default: "p"
    },
    styleGroup: {
      type: String,
      required: true
    },
    get: {
      type: Function as PropType<(brand: Brand) => string>,
      required: true
    },
    set: {
      type: Function as PropType<(brand: Brand, value: string) => void>,
      required: true
    }
  },
  setup(props) {
    const { brand } = injectBrand();

    const fontId = computed(
      () => props.get(brand.value) || Object.keys(brand.value.fonts)[0]
    );

    const { targetEl } = composePopoverForm(props.styleGroup, [
      {
        type: "font",
        get: () => {
          return props.get(brand.value) || Object.keys(brand.value.fonts)[0];
        },
        set: (value: string) => props.set(brand.value, value)
      }
    ]);

    return {
      fontId,
      targetEl,
      testClassName: computed(
        () =>
          "text-style-" +
          props.styleGroup
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
